export default "__VITE_ASSET__CbpSoTXq__"